module.exports = __webpack_public_path__ + "static/media/profile.2747d0ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/svg/profile.svg
// module id = 1037
// module chunks = 0